import { Link } from 'react-router-dom';


const Menu = ({menuHandler}) => {
    return (
        <div className='row'>
            <div className='row' id="image-section">
                <div className='col-sm-12'>
                    <img src={'/pic.jpeg'} className="img-rounded" alt="my Pic"  id="my-image" />   
                </div>            
            </div>
            <div className='row' id="menu-section">
                <div className='col-sm-12'>
                    <ul className='menu'>
                        <li className='menu-item' key={"about"}>
                            <Link to="/about" className='menu-anchor' onClick={menuHandler} value="about">About Me</Link>
                        </li>
                        <li className='menu-item' key={"exp"}>
                            <Link to="/exp" className='menu-anchor' onClick={menuHandler} value="exp">Experiences</Link>
                        </li>
                        <li className='menu-item' key={"edu"}>
                            <Link to="/edu" className='menu-anchor' onClick={menuHandler} value="edu">Education</Link>
                        </li>
                        <li className='menu-item' key={"findme"}>
                            <Link to="/find" className='menu-anchor' onClick={menuHandler} value="find">Find Me</Link>
                        </li>
                    </ul>      
                </div>         
            </div>
    
        </div>
    );
}

export default Menu;
